import {Fragment} from 'react';
import parse from 'html-react-parser';
import Container from '@/components/atoms/Container';
import type {SubpartAccordionItem} from '@/types';
import styles from './AccordionItem.module.scss';

const cx = (...names: Array<string | false | undefined>) => names.filter(Boolean).join(' ');

/**
 * A structured answer (`{header, subpart, body, footer}`) as the MUI SimpleAccordion rendered it: header, each
 * sub-section with its numbered key points, body, footer. The global class names are kept: globals.scss and
 * questions.scss style them.
 */
const StructuredAnswer = ({answer}: {answer: SubpartAccordionItem['answer']}) => (
    <div className={cx('muiAccordionDetails answer-detail-wrapper', styles.details, styles.subDetails)}>
        <div className={cx('answer-detail-header data_links ', styles.text)}>{answer?.header ? parse(answer.header) : ''}</div>
        {answer?.subpart?.map((answerData, answerIndex) => (
            <div key={answerIndex} className="sub-answer-wrapper">
                <div className={cx('answer-sub-heading font-regular-text', styles.text)}>{answerData?.heading}</div>
                {answerData?.keypoints?.map((subdata, keypointsIndex) => (
                    <Fragment key={keypointsIndex}>
                        <Container>
                            <div className={cx('answer-key-head', styles.text)}>{subdata?.keyHeading}</div>
                            <ol className={cx('answer-list-wrapper', styles.list)}>
                                <li className={cx('answer-list-items', styles.listItem)}>
                                    <div className={cx('answer-key-body data_links answer', styles.text)}>
                                        {subdata?.keyBody ? parse(subdata.keyBody) : ''}
                                    </div>
                                </li>
                            </ol>
                        </Container>
                    </Fragment>
                ))}
            </div>
        ))}
        <p className={cx('answer-detail-footer data_links answer', styles.text)}>{answer?.body ? parse(answer.body) : ''}</p>
        <div className={cx('answer-detail-footer', styles.text)}>{answer?.footer ? parse(answer.footer) : ''}</div>
    </div>
);

export default StructuredAnswer;
